<apx-chart
  [series]="apexPieChartOptions.series"
  [chart]="apexPieChartOptions.chart"
  [labels]="apexPieChartOptions.labels"
  [colors]="apexPieChartOptions.colors"
></apx-chart>
<!--  -->